module.exports = __webpack_public_path__ + "media/images/icons/arrow-circle-bottom-4b6449fd94c1eda523704fc7e27580b0.svg";